define("shared/components/shared/contact-us-modal", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{@close}} data-test-id="contact-us-modal" as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header @title={{@title}} />
      <modal.card-body>
        <p>{{html-safe @subtitle}}</p>
      </modal.card-body>
      <modal.card-footer>
        <Shared::Ui::Button
          @additional="block"
          @onClick={{fn this.openChatbot "contact_us_custom_legacy"}}
          @text={{t "customer_support.can_contact.continue"}}
          @variant="outline"
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  
  {{yield}}
  */
  {
    "id": "wMehyxo7",
    "block": "[[[8,[39,0],[[24,\"data-test-id\",\"contact-us-modal\"]],[[\"@close\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],null,[[\"@title\"],[[30,3]]],null],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[12],[1,[28,[35,1],[[30,4]],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,2],null,[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[28,[37,3],[[30,0,[\"openChatbot\"]],\"contact_us_custom_legacy\"],null],[28,[37,4],[\"customer_support.can_contact.continue\"],null],\"outline\"]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]],[1,\"\\n\\n\"],[18,5,null]],[\"@close\",\"modal\",\"@title\",\"@subtitle\",\"&default\"],false,[\"shared/modal\",\"html-safe\",\"shared/ui/button\",\"fn\",\"t\",\"yield\"]]",
    "moduleName": "shared/components/shared/contact-us-modal.hbs",
    "isStrictMode": false
  });

  let ContactUsModalComponent = (_class = class ContactUsModalComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "ada", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "router", _descriptor3, this);

      _initializerDefineProperty(this, "segment", _descriptor4, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor5, this);
    }

    get subscription() {
      return this.subscriptions.subscription;
    }

    openChatbot(buttonText) {
      this.ada.open();
      this.segment.track('clicked-plans-switch-modal', {
        button_text: buttonText,
        plan_interval: this.subscriptions.subscriptionPlan.interval,
        plan_scheduled_end: this.subscription.activeUntil,
        plan_start: this.subscription.createdDate,
        user_id: this.auth.currentUserModel.id
      });
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "ada", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "openChatbot", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openChatbot"), _class.prototype)), _class);
  _exports.default = ContactUsModalComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ContactUsModalComponent);
});